console.log('stocklist');
 
import { on_ready, is_elementor_edit } from 'js/utils'; 
import Dropdown from 'classes/Dropdown';

const dropdown_open_animation = 'fade-in-bottom-short 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both';
let container = document.querySelector('.stocklist-overview .results');
let section = document.querySelector('.stocklist-section .results');
var html_data = JSON.parse(ff_stocklist_data); 

let loadIndex = 0;
const perLoad = 6; // limit items
let activeList = []; // store filtered homes

const formatPrice = (value) => {
    if (!value) return '';
    return Number(value).toLocaleString('en-US'); 
};
 
function renderStatusButton(home) {
    const status = home.status || 'enquire';

    const map = {
        enquire: { 
            text: 'Enquire', 
            class: 'btn-enquire',
            disabled: false
        },
        pending: { 
            text: 'Pending', 
            class: 'pending',
            disabled: true
        },
        sold: { 
            text: 'Sold', 
            class: 'sold',
            disabled: true
        }
    }; 
 
    const item = map[status];

    const typeMap = {
        'single-storey': 'single',
        'dual-living': 'dual living',
        'duplex': 'duplex'
    };

    const home_type = typeMap[home.type] || '';

    return `
        <button
            class="btn small link_btn status ${item.class}"
            data-title="${home.title || ''}"
            data-type="${home_type}"
            data-lot="${home.lot || ''}"
            ${item.disabled ? 'disabled' : ''}
        >
            ${item.text}
        </button>
    `;
}

import './styles.scss'; 

on_ready(()=>{

    if( is_elementor_edit() ) return;
    
    convert_dropdown(); 
    
    if(container){

        // renderHomes(html_data.items_data);
 
        // // document.querySelector('.sort').addEventListener('change', filterHomes); 
        // const sortSelect = document.querySelector('.sort');
        // if (sortSelect) {
        //     sortSelect.addEventListener('change', () => filterHomes());
        // }
        
        // document.getElementById("filter-search").addEventListener("click", () => {
        //     filterHomes();
        // });

        // applyFiltersFromURL();

        // Sort Price Low To High
        const sortSelect = document.querySelector('.sort');
        if (sortSelect) {
            sortSelect.value = 'price-low-high';
        }
       
        const sortedData = sortHomes(
            [...html_data.items_data],
            'price-low-high'
        );

        renderHomes(sortedData);

        if (sortSelect) {
            sortSelect.addEventListener('change', () => filterHomes());
        }

        document.getElementById("filter-search").addEventListener("click", () => {
            filterHomes();
        });

        applyFiltersFromURL();

    }

    if(section){
        renderHomes(html_data.items_data,section); 
    } 

    stocklist_form_button();
    
});

function convert_dropdown(){
    // const dropdownAll = document.querySelectorAll('.filter_container select');
    const dropdownAll = document.querySelectorAll('.filter_container select, .sort_parent select');
    dropdownAll.forEach(dropdown=>{
        new Dropdown(dropdown, {
            animation_open: dropdown_open_animation,
            on_select: (value)=>{
                dropdown.value = value; 
                jQuery(dropdown).trigger('change');
            },  
        });
    })
} 

function renderHomes(data,cont = container) {
    cont.classList.add("transitioning");
    setTimeout(() => {

        loadIndex = 0;          
        activeList = data;      
        cont.innerHTML = ''; 

        const firstItems = data.slice(0, perLoad);
        loadIndex = perLoad;

        cont.innerHTML = firstItems.map(home => renderHomeItem(home)).join('');

        const btn = document.querySelector('.stocklist-overview .load-more');
    
        if (!btn) return;

        if (data.length <= perLoad) {
            btn.style.display = 'none';
        } else {
            btn.style.display = 'block';
        }

        renderLoadMore();

        stocklist_form_button();
    
        requestAnimationFrame(() => {
            cont.classList.remove("transitioning");
        });

    }, 250);
}


function renderHomeItem(home) { 

    const typeMap = {
        'single-storey': 'single',
        'dual-living': 'dual living',
        'duplex': 'duplex'
    };

    const home_type = typeMap[home.type] || '';

    return `
        <div class="item hd-item-2" 
             data-type="${home.type || ''}" 
             data-state="${home.state || ''}" 
             data-region="${home.region || ''}" 
             data-land-size="${home.land_size || ''}"
             data-land-price="${home.land_price || ''}"
             data-build-size="${home.build_size || ''}"
             data-build-price="${home.build_price || ''}"
             data-total-price="${home.total_price || ''}">
            
            <div class="s1 image_fit">
                <div class="x1">
                    <span class="type">${home_type || ''}</span>
                </div>
                ${home.image ? `<img src="${home.image}">` : ''}
            </div>

            <div class="s2">
                <div class="x1">
                    
                    <div class="x1-b">
                        <div class="name"><h4>${home.title || ''}</h4></div>
                        <div class="buttons-box">                    
                            <a href="${home.home_design_link}" class="btn small secondary link_btn">view home design</a>
                            ${renderStatusButton(home)}
                        </div>
                    </div>
                </div>

                <div class="x2 details-con">
                    <div class="x2-a info">
                        ${home.lot ? `<div class="house-area"><span class="c">Lot: </span>${home.lot}</div>` : ''}
                        ${home.region ? `<div class="home-region"><span class="c">Region: </span>${home.region}</div>` : ''}
                        ${home.state ? `<div class="home-state"><span class="c">State: </span>${home.state}</div>` : ''}
                    </div>
                    <div class="x2-b info">
                        ${home.land_size ? `<div class="land_size"><span class="c">land: </span>${home.land_size}<span class="sqm">m<sup>2</sup></span></div>` : ''}
                        ${home.build_size ? `<div class="build_size"><span class="c">build: </span>${home.build_size}<span class="sqm">m<sup>2</sup></span></div>` : ''}
                        ${home.registration ? `<div class="registration"><span class="c">registration: </span>${home.registration}</div>` : ''} 
                    </div>
                </div>

                <div class="x3 info">
                    ${home.land_price ? `<div class="land_price"><span class="c">land: </span>$${formatPrice(home.land_price)}</div>` : ''}
                    ${home.build_price ? `<div class="build_price"><span class="c">build: </span>$${formatPrice(home.build_price)}</div>` : ''}
                    ${home.total_price ? `<div class="total_price"><span class="c">total price: </span>$${formatPrice(home.total_price)}</div>` : ''} 
                </div>

                <div class="x4">
                    <a href="${home.home_design_link}" class="btn small secondary link_btn">view home design</a>
                    
                    ${renderStatusButton(home)}

                </div>
            </div>
        </div>
    `;
}


function filterHomes(returnDataOnly = false) { 

    const state = document.querySelector('.filter-state-cat').value;
    const region = document.querySelector('.filter-region-cat').value;
    const type = document.querySelector('.filter-type-cat').value;
     
    let filtered = html_data.items_data.filter(home => {
        return (!state || home.state === state) &&
               (!region || home.region === region) &&
               (!type || home.type === type);
    });

    const sortValue = document.querySelector('.sort').value;
    filtered = sortHomes(filtered, sortValue);

    if (returnDataOnly) return filtered;

    if (filtered.length > 0) {
        renderHomes(filtered);
    } else {
        container.innerHTML = `<div class="no-results">No results found.</div>`;
    }
 
    const shareBtn = document.querySelector("#shareBtn");
    shareBtn.style.display = "inline-block"; 
    updateShareButton();

    return filtered;
}

function sortHomes(data, sortValue) {
    
    return data.sort((a, b) => {
 
        const designA = a;
        const designB = b; 

        switch(sortValue) {
            case 'name-asc':
                return (designA.title || '').localeCompare(designB.title || '');
            case 'name-desc':
                return (designB.title || '').localeCompare(designA.title || '');
            case 'land-low-high':
                return (designA.land_size || 0) - (designB.land_size || 0);
            case 'land-high-low':
                return (designB.land_size || 0) - (designA.land_size || 0);
            case 'build-low-high':
                return (designA.build_size || 0) - (designB.build_size || 0);
            case 'build-high-low':
                return (designB.build_size || 0) - (designA.build_size || 0);
            case 'price-low-high':
                return (designA.total_price || 0) - (designB.total_price || 0);
            case 'price-high-low':
                return (designB.total_price || 0) - (designA.total_price || 0);
            default:
                return 0;
        }
    });
}

function renderLoadMore() {
    const btn = document.querySelector('.stocklist-overview .load-more');

    if (!btn) return;

    if (activeList.length <= perLoad) {
        btn.style.display = 'none';
        return;
    }

    if (loadIndex >= activeList.length) {
        btn.style.display = 'none';
    } else {
        btn.style.display = 'block';
    }

    btn.onclick = () => {
        const nextItems = activeList.slice(loadIndex, loadIndex + perLoad);
        loadIndex += perLoad;

        container.insertAdjacentHTML(
            'beforeend',
            nextItems.map(home => renderHomeItem(home)).join('')
        );
 
        if (loadIndex >= activeList.length) {
            btn.style.display = 'none';
        }
    };
}

 
function getParams() {
    const params = new URLSearchParams(window.location.search);
    return {
        state: params.get("state") || "",
        region: params.get("region") || "",
        type: params.get("type") || "",
        //sort: params.get("sort") || "",
    };
}
 
function applyFiltersFromURL() {
    const p = getParams(); 

    if (!p.state && !p.region && !p.type && !p.sort) {
        return; 
    }

    if (p.state) { 
        const btn = document.querySelector(`.filter_state .dropdown_style [data-target="${p.state}"]`);
        if (btn) btn.click();
    }

    if (p.region) {
        const btn = document.querySelector(`.filter_region .dropdown_style [data-target="${p.region}"]`);
        if (btn) btn.click();
    }

    if (p.type) {
        const btn = document.querySelector(`.filter_type .dropdown_style [data-target="${p.type}"]`);
        if (btn) btn.click();
    }
 
    const searchBtn = document.getElementById("filter-search");
    if (searchBtn) searchBtn.click();
}


function updateShareButton() {
    const state = document.querySelector(".filter-state-cat").value;
    const region = document.querySelector(".filter-region-cat").value;
    const type = document.querySelector(".filter-type-cat").value;
    const sort = document.querySelector(".sort").value;

    const params = new URLSearchParams();

    if (state) params.set("state", state);
    if (region) params.set("region", region);
    if (type) params.set("type", type);
    //if (sort) params.set("sort", sort);

    const shareURL = window.location.origin +  window.location.pathname + "?" + params.toString();

    const shareBtn = document.querySelector("#shareBtn"); 

    shareBtn.onclick = () => {
        navigator.clipboard.writeText(shareURL).then(() => {
            shareBtn.classList.add("copied"); 
            setTimeout(() => {
                shareBtn.classList.remove("copied");
            }, 2000);
        });
    };
}
 
function stocklist_form_button() {
    // event delegation on the container
    const container = document.querySelector('.stocklist-overview');

    if (!container) return;

    container.addEventListener('click', function (e) {
        const btn = e.target.closest('.btn-enquire');
        if (!btn) return;

        const enquiryData = {
            home_title: btn.dataset.title,
            home_type: btn.dataset.type,
            home_lot: btn.dataset.lot,
            stock_enq_message: `Please send me ${btn.dataset.title} ${btn.dataset.type} package details.`
        };

        elementorProFrontend.modules.popup.showPopup({ id: 3246 });

        watchForGravityForm(enquiryData);
    });

    function watchForGravityForm(enquiryData) {
        const popup = document.querySelector('.elementor-popup-modal');
        if (!popup) return;

        const observer = new MutationObserver(() => {
            const form = popup.querySelector('.gform_wrapper');
            if (form) {
                observer.disconnect();
                fillGFFields(enquiryData);
            }
        });

        observer.observe(popup, { childList: true, subtree: true });
    }

    function fillGFFields(enquiryData) {
        for (let key in enquiryData) {

            let field = document.querySelector(`.gfield--input-type-text.${key} input`);

            if (!field) {
                field = document.querySelector(`.gfield--input-type-textarea.${key} textarea`);
            }

            if (field) {
                field.value = enquiryData[key];
                field.dispatchEvent(new Event('input'));
                field.dispatchEvent(new Event('change'));
            }
        }
    }
}